export interface ActivityItem {
  // 活动id
  id: number;
  // 活动状态
  status: ActivityStatusEnum;
  // 活动名称
  title: string;
  // 活动报名数
  num_enroll: number;
  // 活动浏览数
  num_view: number;
  // 活动核销数
  num_wipe: number;
  // 分享链接
  shareData?: ShareOptions;
}

// 活动状态枚举 0 - 未知|初始化 ， 1 - 待发布（草稿），2 - 已发布（报名中），3 - 已结束（截止报名）， 4 - 已删除， 5 - 已停止
export enum ActivityStatusEnum {
  None,
  Draft,
  Underway,
  Ending,
  Delete,
  Stopped
}

export interface ActivityCustomerItem {
  mobile_number: string;
  num_view: number; // 浏览次数
  employee_name: string;
  status: number;
  last_view_time: string;
}

export interface ActivityRankItem {
  // 排名
  ranking: number;
  // 姓名
  name: string;
  // 角色
  department: string;
  // 头像
  avatar: string;
  // 浏览次数
  num_view: number;
  // 分享次数
  num_share: number;
  // 报名人数
  num_enroll: number;
  // 浏览人数
  num_uv: number;
  //  页面展示字段
  show_num_view: { value: string; unit: string };
  show_num_share: { value: string; unit: string };
  show_num_enroll: { value: string; unit: string };
}

export interface ActivityRankSelf {
  // 头像
  avatar: string;
  // 名称
  name: string;
  // 报名数
  num_enroll: number;
  // 当前排名
  ranking: number;
  // 角色
  department: string;
  // 比上一名少
  subtract: number;
}

export interface ShareOptions {
  title: string;
  abstract: string;
  own_url: string;
  image_url: string;
}
